import React from 'react';
import { Card, CardContent } from './ui/card';
import { carriers } from '../mock/data';
import { Award, Plus } from 'lucide-react';

const Carriers = () => {
  const getLogoStyle = (name) => {
    switch(name) {
      case 'Oscar Health':
        return 'max-w-[85px] max-h-[35px] md:max-w-[140px] md:max-h-[51px]';
      case 'Ambetter':
        return 'max-w-[75px] max-h-[56px] md:max-w-[170px] md:max-h-[100px]';
      case 'BlueCross BlueShield':
        return 'max-w-[75px] max-h-[56px] md:max-w-[170px] md:max-h-[100px]';
      case 'Cigna':
        return 'max-w-[140px] max-h-[88px] md:max-w-[295px] md:max-h-[170px]';
      case 'UnitedHealthcare':
        return 'max-w-[120px] max-h-[34px] md:max-w-[300px] md:max-h-[75px]';
      case 'Wellpoint':
        return 'max-w-[90px] max-h-[28px] md:max-w-[170px] md:max-h-[50px]';
      case 'Imperial':
        return 'max-w-[90px] max-h-[34px] md:max-w-[185px] md:max-h-[60px]';
      case 'AmeriHealth':
        return 'max-w-[85px] max-h-[25px] md:max-w-[175px] md:max-h-[46px]';
      case 'Antidote Health':
        return 'max-w-[92px] max-h-[24px] md:max-w-[170px] md:max-h-[40px]';
      default:
        return 'max-w-[90px] max-h-[38px] md:max-w-[220px] md:max-h-[80px]';
    }
  };

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-[#152238] text-white px-4 py-2 rounded-full mb-6">
            <Award className="w-4 h-4" />
            <span className="text-sm font-medium">Contracted with All Major Carriers</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#3B5275] mb-4">
            Your Complete Coverage Options
          </h2>
          <p className="text-sm font-medium text-[#3B5275] max-w-[480px] mx-auto" data-testid="carriers-subtitle">
            We're contracted with every major insurance carrier, so you have access to all available plans.
          </p>
        </div>

        <div className="grid grid-cols-3 gap-3 md:gap-6">
          {carriers.map((carrier) => (
            <Card 
              key={carrier.id}
              className="border-2 hover:border-[#152238] transition-all duration-300 hover:shadow-lg group cursor-pointer bg-white"
            >
              <CardContent className="p-3 md:p-8 flex items-center justify-center h-[88px] md:h-[160px]">
                {carrier.logo ? (
                  <div className="w-full h-full flex items-center justify-center">
                    <img 
                      src={carrier.logo} 
                      alt={`${carrier.name} logo`}
                      className={`${getLogoStyle(carrier.name)} object-contain group-hover:scale-105 transition-transform duration-300`}
                    />
                  </div>
                ) : (
                  <div className="text-center">
                    <div className="w-16 h-16 bg-[#152238] text-white rounded-full flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform duration-300">
                      <span className="text-2xl font-bold">{carrier.name.charAt(0)}</span>
                    </div>
                    <p className="text-sm font-semibold text-gray-800 group-hover:text-[#3B5275] transition-colors">
                      {carrier.name}
                    </p>
                  </div>
                )}
              </CardContent>
            </Card>
          ))}
        </div>

        {/* More Carriers Disclaimer */}
        <div 
          className="mt-10 mx-auto max-w-3xl flex items-start sm:items-center gap-3 bg-[#152238] text-white rounded-xl px-5 py-4"
          data-testid="carriers-more-disclaimer"
        >
          <Plus className="w-5 h-5 text-[#A8B5C8] flex-shrink-0 mt-0.5 sm:mt-0" />
          <p className="text-sm md:text-base text-[#A8B5C8]">
            <span className="font-semibold text-white">And many more.</span> We work with additional carriers beyond those shown here — for both ACA marketplace and private health plans. If you don't see your preferred carrier, just ask.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Carriers;
